const carouselData = [
  {
    title: '悬疑剧迷必看：2026上半年高分佳作盘点',
    desc: '从烧脑推理到心理惊悚，精选五部口碑悬疑大剧，每一部都让你欲罢不能，熬夜追完才过瘾。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20cork%20board%20covered%20in%20case%20photos%20and%20red%20strings%2C%20warm%20desk%20lamp%20lighting%2C%20noir%20atmosphere%20with%20deep%20shadows%2C%20professional%20cinematic%20composition%2C%20suspense%20thriller%20visual%20style%2C%20rich%20amber%20and%20dark%20brown%20tones&width=800&height=500&seq=carousel-topic-01&orientation=landscape',
    tag: '悬疑专题',
  },
  {
    title: '古装美学进化史：从服化道看国剧审美升级',
    desc: '盘点近年古装剧视觉变革，从大唐气象到宋韵风雅，服化道如何成为剧情之外的第二语言。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20costume%20display%20with%20intricate%20embroidery%20details%2C%20ancient%20silk%20robes%20in%20rich%20crimson%20and%20gold%2C%20museum%20quality%20textile%20photography%2C%20soft%20natural%20lighting%20on%20fabric%20textures%2C%20historical%20Chinese%20fashion%20art%20display%2C%20refined%20cultural%20aesthetic&width=800&height=500&seq=carousel-topic-02&orientation=landscape',
    tag: '古装专题',
  },
  {
    title: '刘亦菲新剧热播：从神仙姐姐到都市丽人的蜕变',
    desc: '回顾刘亦菲近年荧幕形象变迁，看这位实力派演员如何在不同类型剧中展现多面魅力。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20elegant%20urban%20lifestyle%20scene%20with%20soft%20natural%20window%20light%2C%20minimalist%20contemporary%20interior%20design%2C%20warm%20neutral%20color%20palette%20with%20subtle%20rose%20accents%2C%20cinematic%20portrait%20lighting%20aesthetic%2C%20sophisticated%20editorial%20photography%20style%2C%20calm%20and%20confident%20atmosphere&width=800&height=500&seq=carousel-topic-03&orientation=landscape',
    tag: '明星专题',
  },
  {
    title: '国产刑侦剧十年：从重案六组到狂飙的进化之路',
    desc: '梳理国产刑侦题材发展脉络，解析《狂飙》等现象级作品如何重新定义国产犯罪剧天花板。',
    img: 'https://readdy.ai/api/search-image?query=Urban%20city%20skyline%20at%20blue%20hour%20with%20police%20car%20lights%20reflecting%20on%20wet%20street%2C%20dramatic%20noir%20atmosphere%2C%20modern%20Chinese%20cityscape%20with%20neon%20signs%2C%20cinematic%20crime%20drama%20visual%20style%2C%20deep%20contrast%20between%20cool%20steel%20tones%20and%20warm%20street%20lights&width=800&height=500&seq=carousel-topic-04&orientation=landscape',
    tag: '行业专题',
  },
  {
    title: '暑期档追剧指南：十大新剧抢先看排播表',
    desc: '2026暑期档即将开启，多部重磅大剧蓄势待发。一文掌握暑期排播信息，提前锁定你的追剧日历。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20vibes%20with%20beach%20sunset%20and%20comfortable%20outdoor%20movie%20setup%2C%20warm%20golden%20hour%20lighting%2C%20relaxed%20entertainment%20lifestyle%20scene%2C%20string%20lights%20and%20cozy%20atmosphere%2C%20cinematic%20wide%20composition%20with%20ocean%20horizon%2C%20vibrant%20yet%20warm%20summer%20color%20palette&width=800&height=500&seq=carousel-topic-05&orientation=landscape',
    tag: '排播专题',
  },
  {
    title: '仙侠剧还能怎么拍？从与凤行看类型创新方向',
    desc: '仙侠题材面临审美疲劳，《与凤行》等新作如何在传统框架中寻找突破，为经典类型注入新鲜活力。',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20mountain%20landscape%20with%20misty%20peaks%20and%20ancient%20temple%20silhouettes%2C%20soft%20diffused%20morning%20light%20breaking%20through%20clouds%2C%20Chinese%20fantasy%20painting%20aesthetic%2C%20dreamy%20atmosphere%20with%20golden%20and%20jade%20green%20tones%2C%20cinematic%20fantasy%20composition%2C%20immersive%20magical%20world&width=800&height=500&seq=carousel-topic-06&orientation=landscape',
    tag: '仙侠专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-focus-2-line"></i>
            深度内容
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门专题</h2>
          <p className="mt-2 text-foreground-500 text-sm">编辑团队精心策划，深度解读热门剧集与行业趋势</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.parentElement!.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2 py-0.5 rounded text-[10px] font-semibold bg-primary-100 text-primary-700 mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}